import { fastapiInstance } from './client';
import { s3uploadInstance } from './client';
import { resultApiInstance } from './client';

// 중요어 추출
function getImportantWords(data) {
  return fastapiInstance({
    url: '/saaipeer-keywords',
    method: 'post',
    data,
  });
}

// 응답분석결과 추출
function getResponseAnalysisResult(data) {
  return fastapiInstance({
    url: '/saaipeer-grader',
    method: 'post',
    data,
  });
}

function getToken() {
  const token = document.cookie.match('(^|;) ?token=([^;]*)(;|$)');
  return token ? token[2] : null;
}

// 분석 결과 저장
function postGradingResultData(data) {
  const token = getToken();
  return resultApiInstance({
    url: `v1/response-analysis`,
    method: 'post',
    headers: {
      authorization: token,
      'Content-Type': 'application/json',
    },
    data,
  });
}

// 분석 결과 조회
function getAnalysisPaperData() {
  const token = getToken();
  return resultApiInstance({
    url: '/v1/response-analysis',
    method: 'get',
    headers: {
      authorization: token,
      'Content-Type': 'multipart/form-datas;',
    },
  });
}

// 분석 결과 세부 조회
function getDetailAnalysisPaperData(examid) {
  const token = getToken();
  return resultApiInstance({
    url: '/v1/analysis_result_read/' + examid,
    method: 'get',
    headers: {
      authorization: token,
      'Content-Type': 'multipart/form-datas;',
    },
  });
}

// 중요어 목록 조회
function getResultImportantKeyword(examid) {
  const token = getToken();
  return resultApiInstance({
    url: '/v1/analysis_result_read/' + examid + '/keywords',
    method: 'get',
    headers: {
      authorization: token,
      'Content-Type': 'multipart/form-datas;',
    },
  });
}

// 보고서 생성
function getAnalysisReport(data) {
  return s3uploadInstance({
    url: '/saaipeer-report',
    method: 'post',
    data,
  });
}

// 개선된 피드백 추출 (GPT)
async function getImprovedFeedback(data) {
  return fastapiInstance({
    url: '/improved-feedback',
    method: 'post',
    data,
  });
}

export {
  getImportantWords,
  getResponseAnalysisResult,
  postGradingResultData,
  getAnalysisPaperData,
  getDetailAnalysisPaperData,
  getResultImportantKeyword,
  getAnalysisReport,
  getImprovedFeedback
};
